/**
 * Secondary school subject presets by form (Form 1–4).
 * Form 1 matches the admin-provided list. Forms 2–4 reuse the same titles,
 * compulsory/elective flags, and periods/week, with subject codes adjusted
 * (e.g. Mat111 → Mat211 → Mat311 → Mat411) so admins can edit before save.
 */

const BASE_SUBJECTS = [
    { key: "mat", subName: "Mathematics", subCode: "Mat111", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "phy", subName: "Physics", subCode: "Phy111", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "his", subName: "History", subCode: "His111", sessions: "2", isElective: true, mieSyllabusCode: "" },
    { key: "hec", subName: "Home Economics", subCode: "Hec111", sessions: "4", isElective: true, mieSyllabusCode: "" },
    { key: "eng", subName: "English", subCode: "eng111", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "chc", subName: "Chichewa", subCode: "chc111", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "agr", subName: "Agriculture", subCode: "Ag111", sessions: "4", isElective: true, mieSyllabusCode: "" },
    { key: "com", subName: "Computer Studies", subCode: "com111", sessions: "2", isElective: true, mieSyllabusCode: "" },
    { key: "ls", subName: "Life Skills", subCode: "LS111", sessions: "2", isElective: true, mieSyllabusCode: "" },
    { key: "chem", subName: "Chemistry", subCode: "chem111", sessions: "4", isElective: true, mieSyllabusCode: "" },
    { key: "bio", subName: "Biology", subCode: "bio111", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "geo", subName: "Geography", subCode: "GEO111", sessions: "2", isElective: false, mieSyllabusCode: "" },
    { key: "bk", subName: "Bible Knowledge", subCode: "BK111", sessions: "2", isElective: true, mieSyllabusCode: "" },
];

/** @param {string} code @param {number} formNum 1–4 */
function subCodeForForm(code, formNum) {
    if (formNum <= 1 || !code || code.length < 3) return code;
    return `${code.slice(0, -3)}${formNum}${code.slice(-2)}`;
}

function buildPreset(base, formLevel, formNum) {
    const subCode = subCodeForForm(base.subCode, formNum);
    const type = base.isElective ? "Elective" : "Compulsory";
    return {
        id: `f${formNum}-${base.key}`,
        formLevel,
        label: `${base.subName} — ${subCode} · ${type} · ${base.sessions} p/w`,
        subName: base.subName,
        subCode,
        sessions: base.sessions,
        isElective: base.isElective,
        mieSyllabusCode: base.mieSyllabusCode || "",
    };
}

const FORM_LEVELS = ["Form 1", "Form 2", "Form 3", "Form 4"];

/** @type {Record<string, ReturnType<typeof buildPreset>[]>} */
export const PRESETS_BY_FORM = FORM_LEVELS.reduce((acc, label, idx) => {
    const formNum = idx + 1;
    acc[label] = BASE_SUBJECTS.map((b) => buildPreset(b, label, formNum));
    return acc;
}, {});

export const FORM_LEVEL_ORDER = [...FORM_LEVELS];

const ALL_FLAT = FORM_LEVEL_ORDER.flatMap((level) => PRESETS_BY_FORM[level]);

export function getPresetById(id) {
    return ALL_FLAT.find((p) => p.id === id) || null;
}

/** @param {string} formLevel e.g. "Form 1" */
export function getPresetsForForm(formLevel) {
    return PRESETS_BY_FORM[formLevel] || [];
}
